const WEEKDAYS: string[] = [
  'воскресенье',
  'понедельник',
  'вторник',
  'среда',
  'четверг',
  'пятница',
  'суббота',
];

export const getNameWeekDay = (index: number): string => WEEKDAYS[index] ?? '';
